import saunaBnbCakeLp from "../abis/production/saunaBnb/cakeLp";

const host = "https://bscscan.com/address";

export default [
  {
    name: "SAUNA-BNB Cake LP",
    type: "bnb",
    contractAddress: "0x555808D7e7b82b9beeF6388b65E1d98cF6069F75",
    minApr: 159,
    abi: saunaBnbCakeLp.abi,
    url: `${host}/0x555808D7e7b82b9beeF6388b65E1d98cF6069F75`,
    decimals: 18,
  },
];
